//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import quillConfig from './quill-config.js';
export default {
    data() {
        return {
            userInfo: JSON.parse(localStorage.getItem('userInfo')),
            formData: {
                title: '',
                subTitle: '',
                content: ''
            },
            uploadLists: [],
            columns: [],
            typeIndex: 0,
            items: [],
            valueTree: null,
            // 富文本编辑器配置
            editorOption: quillConfig,
            hotelList: [],
            peripherylList: [],
            scenicList: [],
            content: '',
            paramsL: [],
            url: '',
            indx: 1,
            optionsTree: [
                {
                    id: '类型',
                    label: '类型',
                    children: [
                        {
                            id: '1类型',
                            label: '乡村'
                        },
                        {
                            id: '2类型',
                            label: '目的地'
                        },
                        {
                            id: '3类型',
                            label: '景点'
                        }
                    ]
                },
                {
                    id: '玩法',
                    label: '玩法',
                    children: [
                        {
                            id: '1玩法',
                            label: '寻访'
                        },
                        {
                            id: '2玩法',
                            label: '越野'
                        },
                        {
                            id: '3玩法',
                            label: '爬山'
                        },
                        {
                            id: '4玩法',
                            label: '徒步'
                        },
                        {
                            id: '5玩法',
                            label: '摄影'
                        },
                        {
                            id: '6玩法',
                            label: '滑雪'
                        },
                        {
                            id: '7玩法',
                            label: '越野'
                        }
                    ]
                },
                {
                    id: '业务推广',
                    label: '业务推广',
                    children: [
                        {
                            id: '1业务推广',
                            label: '热门'
                        },
                        {
                            id: '2业务推广',
                            label: '推荐'
                        },
                        {
                            id: '3业务推广',
                            label: '清真'
                        },
                        {
                            id: '4业务推广',
                            label: '红色旅游'
                        },
                        {
                            id: '5业务推广',
                            label: '特色街区'
                        },
                        {
                            id: '6业务推广',
                            label: '精选'
                        },
                        {
                            id: '7业务推广',
                            label: '网红'
                        },
                        {
                            id: '8业务推广',
                            label: '乡村置顶'
                        },
                        {
                            id: '9业务推广',
                            label: '乡村推荐'
                        },
                        {
                            id: '10业务推广',
                            label: '首推'
                        },
                        {
                            id: '11业务推广',
                            label: '置顶'
                        },
                        {
                            id: '12业务推广',
                            label: '最热'
                        },
                        {
                            id: '13业务推广',
                            label: '精华'
                        }
                    ]
                },
                {
                    id: '主题',
                    label: '主题',
                    children: [
                        {
                            id: '1主题',
                            label: '自驾游'
                        },
                        {
                            id: '2主题',
                            label: '周边游'
                        },
                        {
                            id: '3主题',
                            label: '养生游'
                        },
                        {
                            id: '4主题',
                            label: '美食游'
                        },
                        {
                            id: '5主题',
                            label: '观演游'
                        },
                        {
                            id: '6主题',
                            label: '修学游'
                        },
                        {
                            id: '7主题',
                            label: '研学游'
                        },
                        {
                            id: '8主题',
                            label: '冰雪游'
                        },
                        {
                            id: '9主题',
                            label: '采风游'
                        },
                        {
                            id: '10主题',
                            label: '民俗游'
                        },
                        {
                            id: '11主题',
                            label: '乡村游'
                        },
                        {
                            id: '12主题',
                            label: '蜜月游'
                        },
                        {
                            id: '13主题',
                            label: '团体游'
                        }
                    ]
                }
            ],
            hotelHide: true,
            peripheryHide: true,
            scenicHide: true
        };
    },
    components: {
        Treeselect
    },
    mounted() {
        if (!this.userInfo) {
            this.$router.replace('/login')
        }
        const _this = this;
        if (this.$route.query.id != undefined) {
            _this.getInit();
        }
        const onChangeList = JSON.parse(this.$tools.getStorage('onChangeList'));
        const hotel = JSON.parse(this.$tools.getStorage('hotel'));
        const periphery = JSON.parse(this.$tools.getStorage('periphery'));
        const scenic = JSON.parse(this.$tools.getStorage('scenic'));
        const resultList = JSON.parse(this.$tools.getStorage('resultList'));
        this.valueTree = JSON.parse(this.$tools.getStorage('tag'));

        if (onChangeList != undefined) {
            this.indx = 0;
            if (hotel != null) {
                this.hotelHide = false;
                for (let i = 0; i < hotel.length; i++) {
                    for (let j = 0; j < onChangeList.length; j++) {
                        if (hotel[i]._id == onChangeList[j]) {
                            this.hotelList.push(hotel[i]);
                        }
                    }
                }
            }
            if (periphery != null) {
                this.peripheryHide = false;
                for (let i = 0; i < periphery.length; i++) {
                    for (let j = 0; j < onChangeList.length; j++) {
                        if (periphery[i]._id == onChangeList[j]) {
                            this.peripherylList.push(periphery[i]);
                        }
                    }
                }
            }
            if (scenic != null) {
                this.scenicHide = false;
                for (let i = 0; i < scenic.length; i++) {
                    for (let j = 0; j < onChangeList.length; j++) {
                        if (scenic[i]._id == onChangeList[j]) {
                            this.scenicList.push(scenic[i]);
                        }
                    }
                }
            }
        }

        if (this.$tools.getStorage('img_url')) {
            this.uploadLists.push({ url: this.$tools.getStorage('img_url') });
        }
        if (this.$tools.getStorage('title')) {
            this.formData.title = this.$tools.getStorage('title');
        }
        if (this.$tools.getStorage('subTitle')) {
            this.formData.subTitle = this.$tools.getStorage('subTitle');
        }
        if (this.$tools.getStorage('content')) {
            this.formData.content = this.$tools.getStorage('content');
        }

        // if (this.$tools.getStorage('img_url') == null) {
        //   this.uploadLists = [];
        // }
        // if (this.$tools.getStorage('title') == null) {
        //   this.formData.title = '';
        // }
        // if (this.$tools.getStorage('subTitle') == null) {
        //   this.formData.subTitle = '';
        // }
        // if (this.$tools.getStorage('content') == null) {
        //   console.log(this.$tools.getStorage('content'));
        //   this.formData.content = '';
        // }
    },

    computed: {
        currId() {
            return this.$route.query.id;
            // return '799553477536866304'
        }
    },
    methods: {
        treeClose(e) {
            this.$tools.setStorage('tag', e);
        },

        ///
        handleDelete(file, detail) {
            this.uploadLists.splice(detail.index, 1);
            this.$tools.removeStorage('img_url');
            this.$emit('deleteFile', file);
            return true;
        },

        upload(formData) {
            return new Promise((resolve, reject) => {
                this.$http.post('/api/zuul/wtcp-material/uploads/material/image', formData)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        async afterRead(file) {
            console.log(file, 'filefilefilefile');

            let formData = new FormData();
            formData.append('file', file.file);
            // 此时可以自行将文件上传至服务器
            let res = await this.upload(formData);
            let data = res.data;

            if (data) {
                console.log(data, 'datadatadata');
                
                let img_url = this.PIC_BASE_URL + data[0].filePath;
                this.uploadLists = [];
                this.uploadLists.push({ url: img_url })
                this.formData.pic = data[0].filePath;
                this.$tools.setStorage('img_url', img_url);
            }
        },

        beforeRead(file) {
            if (!['image/jpeg', 'image/jpg', 'image/png'].includes(file.type)) {
                this.$toast('请上传 jpg/jpeg/png 格式图片');
                return false;
            }
            const isLt = file.size / 1024 / 1024 < 200;
            if (!isLt) {
                this.$toast('上传文件大小不能超过 200 MB!');
                return false;
            }
            return true;
        },

        getYjDetail(currId) {
            return new Promise((resolve, reject) => {
                this.$http
                    .get(`/api/wtcp-traveltips/noteSelf/getDetailNote?id=${currId}&access_token=${this.userInfo ? this.userInfo.access_token : ''}`, {
                        headers: {
                            'Access-Control-Allow-Origin': '*',
                            'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
                        }
                    })
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        async getInit() {
            try {
                let result = await this.getYjDetail(this.currId);
                let data = result.data;
                if (data) {
                    this.formData = data.noteSelfRelateEntity || {};
                    this.valueTree =
                        data.noteTagsList.map(item => {
                            return {
                                id: item.id,
                                label: item.tagName
                            };
                        }) || [];
                    const wholeList = [];
                    for (let i = 0; i < data.noteSelfTagsList.length; i++) {
                        wholeList.push(data.noteSelfTagsList[i].tagSourceId);
                        if (data.noteSelfTagsList[i].tagSourceType == 1) {
                            this.hotelList.push(data.noteSelfTagsList[i] || {});
                        } else if (data.noteSelfTagsList[i].tagSourceType == 2) {
                            this.peripherylList.push(data.noteSelfTagsList[i] || {});
                        } else if (data.noteSelfTagsList[i].tagSourceType == 3) {
                            this.scenicList.push(data.noteSelfTagsList[i] || {});
                        }
                    }
                    if (this.$tools.getStorage('onChangeList') == undefined) {
                        this.$tools.setStorage('wholeList', wholeList);
                    }
                    this.uploadLists.push({ url: data.noteSelfRelateEntity.titleImageUrl.includes('http') ?  data.noteSelfRelateEntity.titleImageUrl : this.PIC_BASE_URL + data.noteSelfRelateEntity.titleImageUrl});
                }
            } catch (err) {
                console.log(err);
            }
        },

        toSelectSites(i) {
            if (this.$route.query.id) {
                this.$router.push({
                    name: 'selectSites',
                    query: {
                        id: this.$route.query.id,
                        key: i
                    }
                });
            } else {
                this.$router.push({
                    name: 'selectSites',
                    query: {
                        key: i
                    }
                });
            }
        },
        async handleSave() {
            const hotel = this.hotelList.map(item => {
                return {
                    tagSourceId: item.id,
                    tagTitle: item.tagTitle,
                    tagLon: item.tagLon,
                    tagLat: item.tagLat,
                    tagAddress: item.tagAddress,
                    tagTitleImage: item.tagTitleImage,
                    tagSourceType: '1'
                };
            });

            const periphery = this.peripherylList.map(item => {
                return {
                    tagSourceId: item.id,
                    tagTitle: item.tagTitle,
                    tagLon: item.tagLon,
                    tagLat: item.tagLat,
                    tagAddress: item.tagAddress,
                    tagTitleImage: item.tagTitleImage,
                    tagSourceType: '2'
                };
            });

            const scenic = this.scenicList.map(item => {
                return {
                    tagSourceId: item.id,
                    tagTitle: item.tagTitle,
                    tagLon: item.tagLon,
                    tagLat: item.tagLat,
                    tagAddress: item.tagAddress,
                    tagTitleImage: item.tagTitleImage,
                    tagSourceType: '3'
                };
            });

            const tags = this.valueTree.map(item => {
                return {
                    parentTag: null,
                    tagCatagory: item.id.substring(1),
                    tagName: item.label
                };
            });
            if (this.$tools.getStorage('img_url')) {
                this.url = this.formData.pic;
            } else {
                this.url = this.formData.titleImageUrl;
            }
            const list = hotel.concat(periphery, scenic);
            const params = this.formData;
            this.paramsL = {
                createdDate: null,
                createdUser: null,
                updatedDate: null,
                updatedUser: null,
                title: params.title,
                subTitle: params.title,
                shareTitle: params.title,
                titleImageUrl: this.url,
                summary: params.subTitle,
                content: params.content,
                author: JSON.parse(localStorage.getItem('userInfo')).user.nickname || '佚名',
                clickNum: null,
                likeNum: null,
                shareNum: null,
                favoriteNum: null,
                noteType: '1',
                onlineStatus: 1,
                auditStatus: 0,
                orgId: null,
                fileId: [],
                tags: null,
                selfTags: null,
                noteSelfTagsListModel: {
                    list: list
                },
                noteSelfModel: {
                    noteSelfId: JSON.parse(localStorage.getItem('userInfo')).user.username
                },
                noteTagsListModel: {
                    list: tags
                },
                sortNum: 0
            };
            console.log(this.paramsL);
            this.$dialog
                .confirm({
                    title: '提示',
                    message: '确认更新该游记？'
                })
                .then(() => {
                    this.getTravels(this.currId, this.paramsL).then(res => {
                        if (res.msg === 'success') {
                            sessionStorage.clear();
                            this.$dialog.alert({
                                title: '提示',
                                message: '更新成功！'
                            });
                            this.$router.replace('/travel-content');
                        }
                    });
                });
        },


        getTravels(id, data) {
            return new Promise((resolve, reject) => {
                this.$http
                    .put(`/api/wtcp-traveltips/noteSelf/${id}?access_token=${this.userInfo ? this.userInfo.access_token : ''}`, data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },


        handleSubmit() {
            // this.check();
            const self = this;
            const hotel = this.hotelList.map(item => {
                return {
                    tagSourceId: item._source.id,
                    tagTitle: item._source.title,
                    tagLon: item._source.geoPoint.split(',')[1],
                    tagLat: item._source.geoPoint.split(',')[0],
                    tagAddress: item._source.address,
                    tagTitleImage: item._source.images[0],
                    tagSourceType: '1',
                    _id: item._id
                };
            });
            const periphery = this.peripherylList.map(item => {
                return {
                    tagSourceId: item._source.id,
                    tagTitle: item._source.title,
                    tagLon: item._source.geoPoint.split(',')[1],
                    tagLat: item._source.geoPoint.split(',')[0],
                    tagAddress: item._source.address,
                    tagTitleImage: item._source.images[0],
                    tagSourceType: '2',
                    _id: item._id
                };
            });

            const scenic = this.scenicList.map(item => {
                return {
                    tagSourceId: item._source.id,
                    tagTitle: item._source.title,
                    tagLon: item._source.geoPoint.split(',')[1],
                    tagLat: item._source.geoPoint.split(',')[0],
                    tagAddress: item._source.address,
                    tagTitleImage: item._source.images[0][0].fileUrl,
                    tagSourceType: '3',
                    _id: item._id
                };
            });

            const tags = this.valueTree.map(item => {
                return {
                    parentTag: null,
                    tagCatagory: item.id.substring(1),
                    tagName: item.label
                };
            });

            console.log(this.uploadLists, 'this.uploadLists');


            if (this.formData.pic == undefined) {
                const pic = this.uploadLists[0] ? this.uploadLists[0].url : '';
                this.url = pic
            } else {
                this.url = this.formData.pic;
            }

            const list = hotel.concat(periphery, scenic);
            const params = this.formData;
            this.paramsL = {
                createdDate: null,
                createdUser: null,
                updatedDate: null,
                updatedUser: null,
                title: params.title,
                subTitle: params.title,
                shareTitle: params.title,
                titleImageUrl: this.url,
                // titleImageUrl:params.pic,
                summary: params.subTitle,
                content: params.content,
                author: JSON.parse(localStorage.getItem('userInfo')).nickname || '未知',
                clickNum: null,
                likeNum: null,
                shareNum: null,
                favoriteNum: null,
                noteType: '1',
                onlineStatus: 1,
                auditStatus: 0,
                orgId: null,
                fileId: [],
                tags: null,
                selfTags: null,
                noteSelfTagsListModel: {
                    list: list
                },
                noteSelfModel: {
                    noteSelfId: JSON.parse(localStorage.getItem('userInfo')).user.username
                },
                noteTagsListModel: {
                    list: tags
                },
                sortNum: 0
            };
            this.$dialog
                .confirm({
                    title: '提示',
                    message: '确认发表该游记？'
                })
                .then(() => {
                    this.$http.post(`/api/wtcp-traveltips/noteSelf?access_token=${this.userInfo.access_token || ''}`, this.paramsL)
                        .then(res => {
                            if (res.data.msg === 'success') {
                                sessionStorage.clear();
                                this.$dialog.alert({
                                    title: '提示',
                                    message: '发表成功！'
                                });
                                let timejump = 10;
                                for (let i = timejump; i >= 0; i--) {
                                    timejump--;
                                    if (timejump == 0) {
                                        this.$router.push('/travel-content');
                                    }
                                }
                            }
                        });
                });
        },

        // 失去焦点事件
        onEditorBlur(quill) {
            this.$tools.setStorage('content', this.formData.content);
            // console.log('editor blur!', quill);
        },
        // 获得焦点事件
        onEditorFocus(quill) {
            // console.log('editor focus!', quill);
        },
        // 准备富文本编辑器
        onEditorReady(quill) {
            // console.log('editor ready!', quill);
        },
        // 内容改变事件
        onEditorChange({ quill, html, text }) {
            this.content = html;
        },

        check() {
            if (this.uploadLists.length == 0) {
                this.$toast('请上传封面');
            } else if (this.formData.title == undefined) {
                this.$toast('游记名称不能为空');
            } else if (this.valueTree.length == 0) {
                this.$toast('请选择关联标签');
            } else if (this.formData.subTitle == undefined) {
                this.$toast('摘要不能为空');
            } else if (this.formData.content == undefined) {
                this.$toast('请输入游记内容');
            }
        },
        checkTitle() {
            this.$tools.setStorage('title', this.formData.title);
        },
        checkSubTitle() {
            this.$tools.setStorage('subTitle', this.formData.subTitle);
        }
    }
};
